import { LmIconFilledImageVideoBrush, LmIconOutlineImageVideoBrush } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionProforientationEventsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineImageVideoBrush {...rest} /> : <LmIconFilledImageVideoBrush {...rest} />;

export default IconProfessionProforientationEventsCommon;
